import axios from 'axios';
import { loginreq, req } from './axiosFun';
// 引入config
import config from '../../config/config.js'

var api = config.baseUrl;
// var api ='http://work.miniprogram.api.jihua/'
// 登录接口
export const login = (params) => { return loginreq("post", api+"/api/login", params) };
// 获取用户菜单
export const getcode1 = () => { return axios.get(api+"/api/login/verify")};
// 获取用户菜单
export const menu = (params) => { return axios.get(api+"/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete(api+"/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", api+"/api/User/list", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", api+"/api/User/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete(api+"/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", api+"/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get(api+"/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get(api+"/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", api+"/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get(api+"/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", api+"/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", api+"/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", api+"/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", api+"/api/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get(api+"/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", api+"/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", api+"/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete(api+"/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", api+"/api/Role/list", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", api+"/api/Role/save", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete(api+"/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get(api+"/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", api+"/api/RoleRight/save", params) };

/**
 * 公司管理
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("post", api+"/api/data/serviceadmin", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", api+"/api/data/save", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get(api+"/api/data/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

// 用户管理
export const usersList = (params) => { return req("post", api+"/api/user/useradmin", params) };
export const usersSave = (params) => { return req("post", api+"/api/user/save", params) };
export const usersDelete = (params) => { return axios.get(api+"/api/user/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
export const userSetVip = (params) => { return req("post", api+"/api/user/set_vip", params) };
// 分类管理
export const brandsort = (params) => { return req("post", api+"/api/contents/sortadmin", params) };
export const brandsortSave = (params) => { return req("post", api+"/api/contents/sortsave", params) };
export const brandsortDelete = (params) => { return axios.get(api+"/api/contents/sortdelete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 品牌管理
export const sortlist = (params) => { return req("post", api+"/api/contents/sortadmin", params) };
export const brand = (params) => { return req("post", api+"/api/contents/brandadmin", params) };
export const brandSave = (params) => { return req("post", api+"/api/contents/brandsave", params) };
export const brandDelete = (params) => { return axios.get(api+"/api/contents/branddelete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 产品案例管理
export const productlist = (params) => { return req("post", api+"/api/contents/productlistadmin", params) };
export const brandlist = (params) => { return req("post", api+"/api/contents/brandlistadmin", params) };
export const productSave = (params) => { return req("post", api+"/api/contents/productsave", params) };
export const productDelete = (params) => { return axios.get(api+"/api/contents/productdelete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 宣传视频管理
export const videolist = (params) => { return req("post", api+"/api/contents/videolistadmin", params) };
export const videoSave = (params) => { return req("post", api+"/api/contents/videosave", params) };
export const videoDelete = (params) => { return axios.get(api+"/api/contents/videodelete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 行业咨询
export const service = (params) => { return req("post", api+"/api/service/serviceadmin", params) };
export const serviceSave = (params) => { return req("post", api+"/api/service/servicesave", params) };
export const serviceDelete = (params) => { return axios.get(api+"/api/service/servicedelete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 咨询帮助
export const help = (params) => { return req("post", api+"/api/help/help", params) };
// 大数据浏览记录
export const bigdatabrowse = (params) => { return req("post", api+"/api/data/bigdatabrowse", params) };
export const brandbrowse = (params) => { return req("post", api+"/api/browse/select", params) };
export const infobrowse = (params) => { return req("post", api+"/api/browse/info", params) };
// 系统配置
export const get_system_config = (params) => { return req("get", api+"/api/browse/get_system_config", params) };
export const update_system_config = (params) => { return req("post", api+"/api/browse/update_system_config", params) };
// 行业咨询
export const slide = (params) => { return req("post", api+"/api/Slideshow/list", params) };
export const slideSave = (params) => { return req("post", api+"/api/Slideshow/slidesave", params) };
export const slideDelete = (params) => { return axios.get(api+"/api/Slideshow/slidedelete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 行业咨询
export const productCenterList = (params) => { return req("post", api+"/api/ProductImage/listadmin", params) };
export const productCenterSave = (params) => { return req("post", api+"/api/ProductImage/save", params) };
export const productCenterDelete = (params) => { return axios.get(api+"/api/ProductImage/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 行业咨询
export const Business = (params) => { return req("post", api+"/api/Business/select", params) };
export const BusinessSave = (params) => { return req("post", api+"/api/Business/save", params) };





/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js